import { Box, Button, LinearProgress, Tab, Tabs } from '@mui/material';
import { FilesTable, SummaryPae, TablePAE, ToolsDamInformation } from '../../../../../../components/custom';
import { LayoutBase } from '../../../../../../layouts';
import { CustomAlert, VMenu } from '../../../../../../components/shared';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IListPae, IPae, PaeServices } from '../../../../../../services/api/action-plan/Pae';
import { Add } from '@mui/icons-material';
import { FileServicesBack, IFileServices } from '../../../../../../services/api/files/FileServicesBack';
import { useAuthContext } from '../../../../../../context';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


export const EmergencyPlan = () => {

  //Tabs
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const { userData } = useAuthContext();
  // const permissoes = userData.permissoes;
  const url = useParams();
  const [data, setData] = useState<IListPae[]>([]);
  const [lastPae, setLastPae] = useState<IPae>();
  const navigate = useNavigate();
  const [loadin, setLoadin] = useState<boolean>(false);
  const [dataFilter, setDataFilter] = useState<IFileServices[]>([]);
  const [dataFiles, setDataFiles] = useState<IFileServices[]>([]);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    fetchData();
    setLoadin(true);
    fetchDataFiles();
  }, [url.id]);

  const paePermissionsString: string | undefined = useMemo(() => {
    return userData?.nivel_acesso?.PAE?.PAE;
  }, [userData]);

  const hasPaePermission = useCallback((action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
    if (typeof paePermissionsString === 'string' && paePermissionsString !== '') {
      return paePermissionsString.includes(action);
    }
    return false;
  }, [paePermissionsString]);


  const fetchData = () => {
    setAlertInfo({ open: false, message: '', severity: 'info' });
    if (url.id) {
      PaeServices.list(url.id)
        .then((response) => {
          if (response instanceof Error) {
            setAlertInfo({ open: true, message: 'Erro ao buscar dados! ' + response.message, severity: 'error' });
          } else {
            setData(response);
            if (response.length > 0) {
              const lastUuid = getMostRecentUuid(response);
              getPae(lastUuid);
            } else {
              setLoadin(false);
              setAlertInfo({ open: true, message: 'Nenhum dado localizado!', severity: 'info' });
            }
          }
        });
    }
  };

  const handleDelete = () => {
    fetchData();
  };


  const getPae = (uuid: string) => {
    PaeServices.get(uuid)
      .then((response) => {
        if (response instanceof Error) {
          // console.log(response.message);
          setLoadin(false);
        } else {
          setLastPae(response);
          setLoadin(false);
        }
      });
  };

  const getMostRecentUuid = (data: IListPae[]): string => {
    const sortedData = data.sort((a, b) => new Date(b.data_emissao).getTime() - new Date(a.data_emissao).getTime());
    return sortedData[0].uuid;
  };


  const showAlert = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
    setAlertInfo({ open: false, message: '', severity: 'info' });
    setTimeout(() => {
      setAlertInfo({ open: true, message, severity });
    }, 100);
  };

  async function handleDeleteFile(valueId: string | undefined) {
    if (valueId !== undefined) {
      FileServicesBack.deleteById(valueId)
        .then((result) => {
          if (result instanceof Error) {
            showAlert('Não foi possível excluir o documento! ' + result.message, 'error');
          } else {
            showAlert('Documento excluído!', 'success');
            fetchDataFiles();
            setDialogOpen(false);
          }
        });
    }
  }

  function handleFileType(newValue: string[] | null) {
    if (newValue !== null) {
      if (newValue.length > 0) {
        if (dataFilter) {
          const filteredData = dataFilter.filter(index => {
            const tipo = index.tipo?.tipo || '';
            const normalizedTipo = tipo.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            return newValue.some(value => {
              const normalizedValue = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
              return normalizedTipo.includes(normalizedValue);
            });
          });
          setDataFilter(filteredData);
        }
      } else {
        setDataFilter(dataFiles);
      }
    } else {
      setDataFilter(dataFiles);
    }
  }

  async function sortedData() {
    if (dataFilter) {
      const sorted = dataFilter.slice().sort((a, b) => {
        if (a.data_emissao && b.data_emissao) {
          const dateA = new Date(a.data_emissao).getTime();
          const dateB = new Date(b.data_emissao).getTime();
          if (sortDirection === 'asc') {
            setSortDirection('desc');
            return dateA - dateB;
          } else {
            setSortDirection('asc');
            return dateB - dateA;
          }
        }
        return 0;
      });
      setDataFilter(sorted);
    }
  }

  const toggleDialog = () => {
    setDialogOpen(!isDialogOpen);
  };

  function handleEditFile(key: string | undefined) {
    if (key !== undefined) {
      navigate(`/information_dam/${url.dam}/files/file/${key}`);
    }
  }

  const fetchDataFiles = () => {
    // console.log('caiu');
    if (url.id) {
      FileServicesBack.get(url.id)
        .then((result) => {
          if (result instanceof Error) {
            setAlertInfo({ open: true, message: `Erro ao buscar arquivos! error: ${result.message}`, severity: 'info' });
          } else {
            const value = result.filter(index => index.tipo.tipo === 'Plano de Ação de Emergência');
            setDataFiles(value);
          }
        });
    }
  };

  return (
    <LayoutBase
      tollBar={<ToolsDamInformation />}
      title='Plano de Ação de Emergência (PAE)'
    >
      <Box flex={1}>
        <VMenu id={url.id} />
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} justifyContent={'space-around'} display={'flex'}>
          <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons allowScrollButtonsMobile>
            <Tab label="RESUMO EXECUTIVO DO ÚLTIMO PLANO DE AÇÃO DE EMERGÊNCIA" {...tabProps(0)} />
            <Tab label="HISTÓRICO" {...tabProps(1)} />
            {/* <Tab label="ARQUIVOS" {...tabProps(2)} /> */}
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <Box display={'flex'} justifyContent={'end'} marginBottom={1}>
            {hasPaePermission('add') &&
              <Button
                onClick={() => navigate('detalhes/novo')}
                variant='contained'
                sx={{ borderRadius: '25px' }}
                startIcon={<Add />}
              >
                Novo
              </Button>
            }
          </Box>
          {loadin ? (
            <LinearProgress />
          ) : (
            lastPae ? (
              <SummaryPae data={lastPae} />
            ) : null
          )}
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <TablePAE
            data={data}
            onDelet={handleDelete}
            hasViewPermission={hasPaePermission('view')}
            hasEditPermission={hasPaePermission('edit')}
            hasRemovePermission={hasPaePermission('remove')}
          />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
          <FilesTable
            dataFilter={dataFiles}
            handleDelete={handleDeleteFile}
            handleFileType={handleFileType}
            sortedData={sortedData}
            url={url}
            title='Arquivos Plano de Ação de Emergência'
            isDialogOpen={isDialogOpen}
            toggleDialog={toggleDialog}
            handleEditFile={handleEditFile}
            type='Plano de Ação de Emergência'
            showAdd={hasPaePermission('add')}
            pagePermissions={paePermissionsString}
          />
        </CustomTabPanel>

      </Box>
      {alertInfo.open &&
        <CustomAlert
          message={alertInfo.message}
          severity={alertInfo.severity}
        />
      }
    </LayoutBase>
  );
};